module.exports = __webpack_public_path__ + "img/mafsi-new-logo-white.8e4e0779.png";